<template>
  <SeeFullTextModal v-bind="$props" />
</template>

<script>
import SeeFullTextModal from "./SeeFullTextModal.vue";

export default {
  name: "MentionDetailModal",
  components: {
    SeeFullTextModal,
  },
  props: {
    mention: {
      type: Object,
      required: true,
    },
  },
};
</script>
